import Vue from "vue";
import { sendEmail } from "../services/api/general";
// import { welcomeMail, emailLayout } from "../utils/templates";

Vue.prototype.$mailer = {
  // emailLayout,
  sendEmail,
  // welcomeMail,
};
